export default {"src":"/bnb/_next/static/media/peckshield.062587d3.svg","height":20,"width":20};